import React from 'react';
import { Link } from 'react-router-dom';
import { ASSETS } from '../utils/assets';

interface FooterProps {
  onContactClick?: () => void;
}

const Footer: React.FC<FooterProps> = ({ onContactClick }) => {
  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onContactClick?.();
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-section">
        <div className="footer-column">
          <img
            src={ASSETS.logoWebp}
            alt="Stimm.DEV Logo"
            className="footer-logo"
          />
          <ul>
            <li><Link to="/">Startseite</Link></li>
            <li>
              <a 
                href="#" 
                onClick={handleContactClick}
                data-action="contact"
              >
                Kontakt
              </a>
            </li>
            <li>
              <Link to="/beratungstermin">
                Termin vereinbaren
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Dienstleistungen</h4>
          <ul>
            <li><a>Mobile App-Entwicklung</a></li>
            <li><a>Webentwicklung</a></li>
            <li><a>Desktop-Software</a></li>
            <li><a>UI/UX Design</a></li>
            <li><a>IT-Beratung</a></li>
            <li><a>Server & Backend</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Ressourcen</h4>
          <ul>
            <li><Link to="/affiliate">Partner-Programm</Link></li>
            <li><a href="/sitemap.xml">Sitemap</a></li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Rechtliches</h4>
          <ul>
            <li><Link to="/impressum">Impressum</Link></li>
            <li><Link to="/privacy">Datenschutzerklärung</Link></li>
            <li><Link to="/agb">Allgemeine Geschäftsbedingungen</Link></li>
          </ul>
          <p className="footer-description">
            Stimm.DEV ist eine führende App-Entwicklungsagentur für KMUs in
            Berlin und ganz Deutschland. Wir bieten maßgeschneiderte mobile
            Apps, Webentwicklung und IT-Beratung.
          </p>
        </div>
      </div>

      <div className="footer-meta">
        <div className="footer-meta-content">
          <span>
            © Stimm.DEV {currentYear} - Henri Stimm - App-Entwicklung & digitale
            Lösungen aus Berlin
          </span>
          <div className="made-with-love">
            Made with 
            <svg className="heart-icon" viewBox="0 0 24 24" fill="white">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
            </svg>
            in Berlin
          </div>
        </div>
        <nav>
          <a
            href="https://www.instagram.com/stimm.dev"
            aria-label="Instagram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={ASSETS.instagram} alt="Instagram" />
          </a>
          <a 
            href="https://t.me/stimmdev" 
            aria-label="Telegram"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={ASSETS.telegram} alt="Telegram" />
          </a>
          <a 
            href="https://www.facebook.com/stimm.dev" 
            aria-label="Facebook"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={ASSETS.facebook} alt="Facebook" />
          </a>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
